import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import ImbibeRealease from'../assets/images/imbibe-release.png'
import ImbibeRealeaseDesktop from'../assets/images/imbibe_wilbert_long.png'


import data from '../data/index'



class HomeIndex extends React.Component {

    render() {

        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description

 
        // Dynamically generate homepage grid images
        let projects = data.map( (project, idx) => (
            <article key={`project-${project.name}`} id={project.id} onClick={this.props.handleClick.bind(this, idx)}>
                <Link to={project.url} className="link primary"></Link>
                    <img src={project.img} />
            </article>
        ));

        return (

            
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                    <link href="//cloud.webtype.com/css/205c6ee8-8be6-4e77-9137-0a8616dac421.css" rel="stylesheet" type="text/css" />
                </Helmet>

                <div id="main">
                    <div style={{textAlign: "center", margin: "auto"}} className="pressImgWrapDesktop">
                        <a  href="https://www.thewilbertgroup.com/media/1814/wilbert_pr_011720.pdf">
                            <img  style={{width: "100%"}} className="pressImg" src={ImbibeRealeaseDesktop}></img>
                        </a>
                    </div>
                    <div style={{textAlign: "center", margin: "auto"}} className="pressImgWrap">
                        <a  href="https://www.thewilbertgroup.com/media/1814/wilbert_pr_011720.pdf">
                            <img  style={{width: "100%"}} className="pressImgDesktop" src={ImbibeRealease}></img>
                        </a>
                    </div>
                    <section id="one" className="tiles">

                        {projects}
                    </section>
                </div>
            </div>
        )
    }
}


export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/index.js